import styled from 'styled-components';

export const ParagraphStyle = styled.p`
  margin: 0;
  padding: 0;
  align-content: center;
  font-family: 'Quicksand', sans-serif;
`;
